<mat-accordion
  multi
  class="w-full"
>
  @if (groupedReports().length) {
    @for (reportGroup of groupedReports(); track reportGroup.key) {
      <mat-expansion-panel
        (opened)="onPanelToggle(reportGroup.key, true)"
        (closed)="onPanelToggle(reportGroup.key, false)"
        [expanded]="isPanelExpanded(reportGroup.key)"
        class="bg-proffeo-surface-muted"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="flex items-center gap-2 min-w-0 overflow-hidden">
            @if (reportGroup.titleTranslationKey) {
              <span class="min-w-0 truncate grouped-row-name">
                {{ reportGroup.titleTranslationKey | translate }}
              </span>
            } @else if (reportGroup.title) {
              <span class="min-w-0 truncate grouped-row-name">{{ reportGroup.title }}</span>
            } @else if (groupingMode() !== GroupingModeEnum.DATE) {
              <span class="min-w-0 truncate grouped-row-name">{{ 'task-filters.emptyValue' | translate }}</span>
            }
            @if (reportGroup.showDate) {
              <span class="shrink-0 whitespace-nowrap">
                @if (reportGroup.date) {
                  {{ reportGroup.date | proffeoDate }}
                } @else {
                  {{ 'task-filters.emptyValue' | translate }}
                }
              </span>
            }
            <span class="text-sm text-proffeo-muted shrink-0">({{ reportGroup.rows.length }})</span>
          </mat-panel-title>
          <mat-panel-description class="flex items-center justify-end shrink-0 grow-0 w-20">
            <span class="text-sm font-semibold text-proffeo-text whitespace-nowrap">
              {{ reportGroup.totalDuration | hmDuration }}
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="overflow-auto">
          <proffeo-reports-data-table
            (selectReport)="toggleTimeReport($event)"
            (selectAll)="selectSession(reportGroup.rows)"
            (editReport)="onEditReport($event)"
            (deleteReport)="onDeleteReport($event)"
            (taskDetailsOpened)="openTaskDetails($event)"
            [rows]="reportGroup.rows"
            [columns]="columns()"
            [selectedIds]="selectedReportIds()"
            [allSelectableIds]="selectableIds(reportGroup.rows)"
            [selectableReportIds]="selectableIds(reportGroup.rows)"
            [selectionDisabled]="selectionDisabled()"
            [showSelectAll]="true"
          />
        </div>
      </mat-expansion-panel>
    }
  } @else {
    <div class="flex w-full items-center justify-center py-10 border border-proffeo-overlay-subtle rounded-md">
      <p class="text-proffeo-muted">{{ 'placeholders.no-results-found' | translate }}</p>
    </div>
  }
</mat-accordion>
